import { CommonModule } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CssListComponent } from '../../advisors/css-list/css-list.component';
import { ManagersListComponent } from '../../advisors/managers-list/managers-list.component';
import { HeroV2026Component } from '../../_components/hero-v2026/hero-v2026.component';
import { DataServiceService } from 'src/app/services/data-service.service';
import { GlobalService } from 'src/app/services/global.service';
import { AdvisorListComponent } from '../../advisors/advisor-list/advisor-list.component';

export interface FeaturedAdvisor {
  fullName: string;
  credentials: string;
  title: string;
  imageUrl: string;
  bioExcerpt: string;
  phone: string;
  phoneHref: string;
  url: string;
}

@Component({
    selector: 'app-about-default',
    templateUrl: './about-default.component.html',
    styleUrls: ['./about-default.component.scss'],
    imports:[RouterModule,CommonModule,CssListComponent,
      ManagersListComponent,
      HeroV2026Component,
      //AdvisorListComponent
    ]
})
export class AboutDefaultComponent implements OnInit {

  title = "About Investing for Catholics.";

  advisors = signal<FeaturedAdvisor[]>([]);

  constructor(private dataservice: DataServiceService, private globalservice: GlobalService) { }

  ngOnInit() {
    this.dataservice.getAdvisor("?$filter=id in (" + this.globalservice.advisors.map(x => x.id) + ")").subscribe(resp => {
      const list = resp.map(x => this.toFeatured(x, x.url.replace("https://www.ifa.com/", "")));
      this.advisors.set(list);

      // Elizabeth Brunson lives in the client-services API on IFA.com
      this.dataservice.getClientServices("?$filter=id%20eq%2069").subscribe(cs => {
        if (cs.length > 0) {
          const url = cs[0].url.replace("https://www.ifa.com/", "").replace("about/", "").replace("-brunson", "");
          this.advisors.set([...list, this.toFeatured(cs[0], url)]);
        }
      });
    });
  }

  private toFeatured(x: any, url: string): FeaturedAdvisor {
    const phone: string = x.phones?.["Toll Free"] || x.phones?.["Local"] || x.phones?.["Cell"] || "";
    return {
      fullName: x.fullName,
      credentials: x.credentials || "",
      title: x.id == 28 ? "Senior Vice President, Wealth Advisor and Co-Founder" : x.title,
      imageUrl: x.imageUrl,
      bioExcerpt: this.firstParagraphs(x.bio || "", 2),
      phone: phone.replace(/-/g, "."),
      phoneHref: "tel:+1" + phone.replace(/\D/g, ""),
      url
    };
  }

  // Keep only the first N <p> blocks of the API-supplied bio HTML, strip inline links
  private firstParagraphs(html: string, n: number): string {
    const paras = html.match(/<p\b[^>]*>[\s\S]*?<\/p>/gi) || [];
    return paras.slice(0, n).join("").replace(/<a\b[^>]*>([\s\S]*?)<\/a>/gi, "$1");
  }

}
